import MiniCart from '@project/components/miniCart';
import { isOverBreakpoint } from './utility';
import Cart from '../cart/cart';

export default class extends MiniCart {
    constructor() {
        super();
        this.updateMiniCart = true;
        this.$body = $('body');
        this.$minicart = $('.minicart');
    }

    init() {
        const cart = new Cart();
        cart.init();
        const self = this;
        this.$body.on('click', '.minicart .popover .popover-close', (e) => {
            e.preventDefault();
            self.minicartHide();
        });
        this.$minicart.on('count:update', (event, count) => {
            self.updateCounter(count);
        });

        this.$minicart.on('mouseenter focusin', () => {
            self.minicartShow();
        });
        this.$body.on('touchstart click', (e) => {
            if (this.$minicart.has(e.target).length <= 0 && $(e.target) !== $('.minicart .popover .popover-close')) {
                self.minicartHide();
            }
        });
        this.$minicart.on('mouseleave focusout', (event) => {
            if ((event.type === 'focusout' && this.$minicart.has(event.target).length > 0)
                || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || this.$body.hasClass('modal-open')) {
                event.stopPropagation();
                return;
            }
            const $popover = $('.minicart .popover');
            if ($popover.length) $popover.removeClass('show');
        });
        this.$body.on('change', '.minicart .quantity', function () {
            if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
                window.location.reload();
            }
        });
        this.$body.on('product:afterAddToCart', () => {
            self.updateMiniCart = true;
            self.minicartShow();
            setTimeout(this.minicartHide, 5000);
        });
        this.$body.on('cart:update', () => {
            self.updateMiniCart = true;
        });
    }

    updateCounter(count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems,
            });
        }
    }

    minicartHide() {
        const $popover = $('.minicart .popover');
        if ($popover) $popover.removeClass('show');
    }

    minicartShow() {
        if ($('.search:visible').length === 0 || !isOverBreakpoint('lg')) {
            return;
        }
        const url = $('.minicart').data('action-url');

        if ($('.minicart .popover.show').length === 0) {
            $('.dropdown-menu').removeClass('show');
            $('.dropdown-toggle').attr('aria-expanded', 'false');
            const $popover = $('.minicart .popover');
            if (!this.updateMiniCart && $popover.length > 0) {
                $popover.addClass('show');
                return;
            }

            $popover.addClass('show');
            $popover.spinner().start();
            const self = this;
            $.get(url, (data) => {
                $popover.empty();
                $popover.append(data);
                const minicartFooterHeight = $('.minicart .popover .minicart-footer').outerHeight() || 202;
                $popover.css('--minicart-footer-height', `${minicartFooterHeight}px`);
                const $tooltip = $('.minicart-tooltip');
                if ($tooltip.length && !$tooltip.data('bs.tooltip')) {
                    $tooltip.tooltip();
                }
                self.updateMiniCart = false;
                $.spinner().stop();
            });
        }
    }
}
